<template>
  <div class="px-2 sm:px-0">
    <div class="flex w-full flex-col sm:flex-row sm:justify-between mb-3 sm:mb-5">
      <p class="self-start hidden sm:flex sm:self-center text-xl font-bold text-purple_dark">
        {{tests.length}} Test Centres
      </p>
      <div class="self-end">
        <button
                @click="addTest()"
                class="sm:w-full flex bg-transparent bg-purple_dark sideBackground text-white font-semibold hover:text-white py-2 px-4 hover: rounded-lg">
          <!--          <PlusIcon class="mr-2 self-center" size="1.1x"></PlusIcon>-->

          Add New Centre
        </button>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <div :key="test.key" class="w-full md:w-1/2 xl:w-1/2  mb-3 sm:mb-6" v-for="test in tests">
        <div class="rounded-lg shadow-lg bg-white sm:mr-4">
          <div class="w-full  p-3">
            <p class="text-2xl capitalize text-purple_dark font-semibold">
              {{test.area}}
            </p>
            <p>
              Latitude : {{test.lat}}
            </p>
            <p>
              Longitude : {{test.lng}}
            </p>
          </div>
          <div class="flex">
            <button @click="edit(test)"
                    class="w-full bg-blue flex justify-center text-white font-semibold hover:text-white py-2 px-4 rounded-bl-lg">
              <Edit3Icon></Edit3Icon>
            </button>
            <button @click="deleteTest(test)"
                    class="w-full hover:bg-red-dark flex justify-center bg-red-medium text-white font-semibold hover:text-white py-2 px-4 rounded-br-lg">
              <Trash2Icon></Trash2Icon>
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import {eventBus} from "../../eventbus";
  import {db} from "../../db";
  import {Trash2Icon, Edit3Icon} from 'vue-feather-icons'

  // import {PlusIcon} from 'vue-feather-icons';
  // import {FingerprintSpinner} from 'epic-spinners'


  export default {
    name: "TestContent",
    props: {
      tests: {
        type: Array,
        required: true
      },
      testsWithKey: {
        type: Array,
        required: true
      }
    },
    data() {
      return {}
    },
    methods: {
      edit(x) {
        eventBus.$emit('EditTest', x)
      },
      addTest() {
        eventBus.$emit('AddTest')

      },
      deleteTest(x) {
        this.$confirm(`Are you sure you want to delete ${x.area} test centre?`, '',
            "error")
            .then(() => {
              let test = this.testsWithKey.find(item => item.area === x.area);
              db.ref('test_centre/' + `${test.key}`).remove().then(() => {
                this.$toast.open({
                  message: 'Successful',
                  type: 'success'
                });
              })
            })
            .catch(() => {
            });
      }
    },
    components: {
      // PlusIcon,
      Trash2Icon, Edit3Icon
      // FingerprintSpinner
    }
  }
</script>

<style scoped>
  /*.pos {*/
  /*  right: 10px;*/
  /*  bottom: 10px;*/
  /*}*/
</style>
